'use client';

import { Provider } from 'jotai';
import { SessionProvider } from 'next-auth/react';
import { I18nextProvider } from 'react-i18next';
import i18n from '@/lib/l18n/config';
import { useSearchParams } from 'next/navigation';
import { resolveLanguage } from '@/lib/l18n/function';

export const JotaiProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => <Provider>{children}</Provider>;

export const AuthProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => <SessionProvider>{children}</SessionProvider>;

export const I18nProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const searchParams = useSearchParams();
  const lang = searchParams.get('lang');
  const resolvedLang = resolveLanguage(lang || undefined);
  i18n.changeLanguage(resolvedLang);
  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
};
